// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Project Container */
.project-container {
    padding: 20px;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 5px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    overflow-y: auto;
    height: 100%;
  }
  
  /* Last Updated Text */
  .project-updated {
    font-size: 0.9em;
    color: #555;
  }
  
  /* Sections */
  .project-section {
    margin-bottom: 20px;
  }
  
  /* Teams Section */
  .project-teams {
    display: flex;
    gap: 10px;
  }
  
  /* Individual Team */
  .project-team {
    flex: 1 1;
    padding: 10px;
    border: 1px solid #ccc;
    border-radius: 5px;
  }
  
  /* Milestones and Timeline */
  .project-timeline-container {
    display: flex;
    justify-content: space-between;
    gap: 20px;
  }
  
  /* Chart Placeholder */
  .project-chart-placeholder,
  .project-timeline-placeholder {
    width: 100%;
    height: 150px;
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
  }
  `, "",{"version":3,"sources":["webpack://./src/styles/Project.css"],"names":[],"mappings":"AAAA,2BAA2B;AAC3B;IACI,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,wCAAwC;IACxC,gBAAgB;IAChB,YAAY;EACd;;EAEA,sBAAsB;EACtB;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA,aAAa;EACb;IACE,mBAAmB;EACrB;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,SAAS;EACX;;EAEA,oBAAoB;EACpB;IACE,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;EACX;;EAEA,sBAAsB;EACtB;;IAEE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB","sourcesContent":["/* Main Project Container */\n.project-container {\n    padding: 20px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n    overflow-y: auto;\n    height: 100%;\n  }\n  \n  /* Last Updated Text */\n  .project-updated {\n    font-size: 0.9em;\n    color: #555;\n  }\n  \n  /* Sections */\n  .project-section {\n    margin-bottom: 20px;\n  }\n  \n  /* Teams Section */\n  .project-teams {\n    display: flex;\n    gap: 10px;\n  }\n  \n  /* Individual Team */\n  .project-team {\n    flex: 1;\n    padding: 10px;\n    border: 1px solid #ccc;\n    border-radius: 5px;\n  }\n  \n  /* Milestones and Timeline */\n  .project-timeline-container {\n    display: flex;\n    justify-content: space-between;\n    gap: 20px;\n  }\n  \n  /* Chart Placeholder */\n  .project-chart-placeholder,\n  .project-timeline-placeholder {\n    width: 100%;\n    height: 150px;\n    background-color: #f0f0f0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5px;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
